import { render, staticRenderFns } from "./VesselType.vue?vue&type=template&id=4f5a0cd3&scoped=true"
import script from "./VesselType.vue?vue&type=script&lang=js"
export * from "./VesselType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a0cd3",
  null
  
)

export default component.exports